<template>
  <div v-loading="formLoading">
    <!-- 主数据信息 -->
    <div class="secondStep form_area">
      <div
        class="masterDataInformation"
        align="center"
        style="margin-bottom: 20px"
        v-if="extForm.subconBaseInfo.approvalStatus == '4'"
      >
        <span
          style="color: red"
          
        >
          <span style="color: #000000">退回意见 : </span>
          {{ extForm.subconBaseInfo.attribute7 }}</span
        >
        <el-button type="primary" @click="showApprovalRecord" style="margin-left: 10px">查看详情</el-button>
      </div>
      <el-form
        :model="extForm"
        ref="ruleForm1"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                prop="subconBaseInfo.subconName"
                :rules="rules1.subconName"
                label="分包商名称（中文）："
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.subconName"
                  placeholder="请输入分包商名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="分包商简称："
                prop="subconBaseInfo.subconShortName"
                :rules="rules1.subconShortName"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.subconShortName"
                  placeholder="请输入分包商简称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- {{extForm.subconBaseInfo}} -->
              <el-form-item
                label-width="190px"
                prop="subconCooUnitInfo.initUnitName"
                :rules="rules1.initUnitName"
                label="初始准入单位："
              >
                <el-input
                  disabled
                  v-model="extForm.subconCooUnitInfo.initUnitName"
                  placeholder="请输入初始准入单位"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- {{extForm.subconBaseInfo}} -->
              <el-form-item
                label-width="190px"
                prop="subconCooUnitInfo.cooUnitName"
                :rules="rules1.cooUnitName"
                label="合作单位："
              >
                <el-input
                  disabled
                  v-model="extForm.subconCooUnitInfo.cooUnitName"
                  placeholder="请输入合作单位"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="190px" label="上级法人单位：">
                <el-input
                  v-model="extForm.subconBaseInfo.subsidiaryGroupName"
                  placeholder="请输入上级法人单位"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="分包商英文名称："
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.subconUsName"
                  @input="extForm.subconBaseInfo.subconUsName=extForm.subconBaseInfo.subconUsName.replace(/[\u4E00-\u9FA5]/g,'')"
                  placeholder="请输入分包商英文名称"
                  maxlength="300"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="是否集团内部单位："
                :rules="rules1.yesNo"
                prop="subconBaseInfo.yesNo"
              >
                <el-radio-group disabled v-model="extForm.subconBaseInfo.yesNo">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="统一社会信用代码："
                :rules="rules1.unifiedCreditCode"
                prop="subconBaseInfo.unifiedCreditCode"
              >
                <el-input
                  disabled
                  placeholder="请输入统一社会信用代码"
                  v-model="extForm.subconBaseInfo.unifiedCreditCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="企业性质："
                :rules="rules1.comNatureName"
                prop="subconBaseInfo.comNatureName"
              >
                <!-- prop="comNatureName" -->
                <!-- <span slot="label">
                  <span class="span-box">
                    <span>企业性质：</span>
                    <el-tooltip
                      style="display: inline; z-index: 1000"
                      effect="dark"
                      content="企业的所有制形式"
                      placement="top"
                    >
                      <i class="el-icon-question" />
                    </el-tooltip>
                  </span>
                </span> -->
                <el-input
                  v-model="extForm.subconBaseInfo.comNatureName"
                  @click.native="centerDialogVisible = true"
                  placeholder="请选择企业性质"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="名称（当地语言）："
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.subconName"
                  placeholder="请输入名称（当地语言）"
                  maxlength="300"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="所在地："
                required
                :error="errorTips1"
                
              >
                <scmaAreaSelector
                  ref="myCascader"
                  :defaultArea="defaultArea"
                  @getAddressOf="getAddressOf"
                  :areaShow="extForm.subconBaseInfo.inputValue"
                  :place="leftPlace"
                  :url="areaUrl"
                  :agentId="paramsData"
                  :headers="headers"
                ></scmaAreaSelector>
              </el-form-item>
            </el-col>
          
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="往来单位类别："
                :rules="rules1.subconCategoryName"
                prop="subconBaseInfo.subconCategoryName"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.subconCategoryName"
                  @click.native="categoryDialogVisible = true"
                  placeholder="请选择往来单位类别"
                ></el-input>
                <!--                <el-select-->
                <!--                  @change="getCategoryCode"-->
                <!--                  v-model="extForm.subconBaseInfo.subconCategoryName"-->
                <!--                  placeholder="请选择"-->
                <!--                >-->
                <!--                  <el-option-->
                <!--                    v-for="item in listSubconCategory"-->
                <!--                    :key="item.categoryCode"-->
                <!--                    :label="item.name"-->
                <!--                    :value="item.categoryCode"-->
                <!--                  ></el-option>-->
                <!--                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="往来单位性质："
                :rules="rules1.subconNatureName"
                prop="subconBaseInfo.subconNatureName"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.subconNatureName"
                  @click.native="natureDialogVisible = true"
                  placeholder="请选择往来单位性质"
                ></el-input>
                <!--<el-select
                  @change="getNatureCode"
                  v-model="extForm.subconBaseInfo.subconNatureName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in listSubconNature"
                    :key="item.natureCode"
                    :label="item.name"
                    :value="item.natureCode"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 1196px !important"></el-row>
        </div>
      </el-form>
    </div>
    <!-- 企业基本信息--注册人信息 -->
    <div class="secondStep form_area">
      <el-form
        :model="extForm.subconAuthAccountInfo"
        :rules="rules2"
        ref="ruleForm2"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--注册人信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册人姓名："
                prop="authUserName"
              >
                <el-input
                  v-model="extForm.subconAuthAccountInfo.authUserName"
                  placeholder="请输入注册人姓名"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册人证件类型："
                prop="cardType"
              >
                <el-select
                  v-model="extForm.subconAuthAccountInfo.cardType"
                  placeholder="请选择"
                  @change="$forceUpdate()"
                >
                  <el-option label="身份证" :value="0"></el-option>
                  <el-option label="护照" :value="1"></el-option>
                  <el-option label="其他" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册人证件号码："
                prop="authPersonIdCard"
              >
                <el-input
                  v-model="extForm.subconAuthAccountInfo.authPersonIdCard"
                  oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                  placeholder="请输入注册人证件号码"
                  maxlength="18"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册人邮箱："
                prop="registerEmail"
              >
                <el-input
                  v-model="extForm.subconAuthAccountInfo.registerEmail"
                  placeholder="请输入注册人邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册人手机号："
                prop="phone"
              >
                <div class="verificationCode">
                  <el-input
                    disabled
                    placeholder="请输入注册人手机号"
                    v-model="extForm.subconAuthAccountInfo.phone"
                    maxlength="11"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col :span="24">-->
          <!--              <el-form-item-->
          <!--                label-width="190px"-->
          <!--                label="分包商类型："-->
          <!--                prop="subconType"-->
          <!--              >-->
          <!--                <el-checkbox-group-->
          <!--                  v-model="extForm.subconBaseInfo.subconType"-->
          <!--                >-->
          <!--                  <el-checkbox label="总承包" name="0"></el-checkbox>-->
          <!--                  <el-checkbox label="专业分包" name="1"></el-checkbox>-->
          <!--                  <el-checkbox label="劳务分包商" name="2"></el-checkbox>-->
          <!--                  <el-checkbox label="其他" name="3"></el-checkbox>-->
          <!--                </el-checkbox-group>-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <el-row style="width: 1196px !important"></el-row>
        </div>
      </el-form>
    </div>
    <!-- 企业基本信息--法人信息 -->
    <div class="secondStep form_area">
      <el-form
        :model="extForm"
        ref="ruleForm3"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--法人信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人姓名："
                prop="subconBaseInfo.legalPersonName"
                :rules="rules3.legalPersonName"
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.legalPersonName"
                  placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人电话号码："
                prop="subconBaseInfo.legalPersonPhone"
                :rules="rules3.legalPersonPhone"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.legalPersonPhone"
                  oninput="value=value.replace(/[^0-9-.]/g,'')"
                  placeholder="请输入法人电话号码"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="www"
                label-width="190px"
                label="法人证件类型："
                prop="subconBaseInfo.cardType"
                :rules="rules3.cardType"
              >

                <el-select
                  v-model="extForm.subconBaseInfo.cardType"
                  @change="$forceUpdate()"
                  placeholder="请选择"
                >
                  <el-option label="身份证" :value="0"></el-option>
                  <el-option label="护照" :value="1"></el-option>
                  <el-option label="其他" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码："
                prop="subconBaseInfo.legalPersonIdCard"
                :rules="rules3.legalPersonIdCard"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.legalPersonIdCard"
                  oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                  placeholder="请输入法人证件号码"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码有效期开始："
                prop="subconBaseInfo.legalPersonCardValidityStart"
                :rules="rules3.legalPersonCardValidityStart"
              >
                <el-date-picker
                  v-model="
                    extForm.subconBaseInfo.legalPersonCardValidityStart
                  "
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
                <!--                <el-date-picker-->
                <!--                  v-model="-->
                <!--                    extForm.subconBaseInfo.legalPersonCardValidityStart1-->
                <!--                  "-->
                <!--                  @change="changePicker"-->
                <!--                  :clearable="false"-->
                <!--                  align="right"-->
                <!--                  type="daterange"-->
                <!--                  value-format="yyyy-MM-dd"-->
                <!--                  range-separator="至"-->
                <!--                  start-placeholder="开始日期"-->
                <!--                  end-placeholder="结束日期"-->
                <!--                  :picker-options="pickerOptions"-->
                <!--                >-->
                <!--                </el-date-picker>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人证件号码有效期结束："
                prop="subconBaseInfo.legalPersonCardValidityEnd"
                :rules="rules3.legalPersonCardValidityEnd"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.legalPersonCardValidityEnd"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
              </el-form-item>
            </el-col>
          </el-row>
    
          <el-row>
            <el-col :span="12">
              <!-- uploadId -->
              <!-- {{JSON.parse(extForm.subconBaseInfo.legalPersonCardFront).uploadId }} -->
              <el-form-item
                ref="uplodFile1"
                label-width="190px"
                label="身份证扫描件正面："
                :rules="rules3.legalPersonCardFront"
                prop="subconBaseInfo.legalPersonCardFront"
              >
                <frontPhotoOfIdCard
                  :uploadUrl="secondFiles.idFront"
                  @uploadUrl="getUrlZm"
                ></frontPhotoOfIdCard>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                ref="uplodFile2"
                label-width="190px"
                label="身份证扫描件反面："
                :rules="rules3.legalPersonCardBack"
                prop="subconBaseInfo.legalPersonCardBack"
              >
                <reversePhotoOfIdCard
                  :uploadUrl="secondFiles.idBack"
                  @uploadUrl="getUrlFm"
                ></reversePhotoOfIdCard>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
          >
            <el-col :span="12">
              <el-form-item
                ref="uplodFile3"
                label-width="190px"
                label="是否法人代表授权委托："
                :rules="rules3.isAuthCertificate"
                prop="subconAuthAccountInfo.isAuthCertificate"
              >
                <el-radio-group v-model="extForm.subconAuthAccountInfo.isAuthCertificate">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
          v-if="extForm.subconAuthAccountInfo.isAuthCertificate == 1"
          >
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="法人代表授权委托书扫描件："
                :rules="rules3.authCertificate"
                prop="subconAuthAccountInfo.authCertificate"
              >
                <faren
                  :uploadUrl="secondFiles.legalRepresentative"
                  @faren="getUrlFr"
                ></faren>
              </el-form-item>
              <el-form-item label-width="190px" label="" prop="11">
                <span
                  style="color: #0089ef; cursor: pointer"
                  @click.stop="download"
                  >下载授权委托书模板</span
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 1196px !important"></el-row>
        </div>
      </el-form>    
    </div>    
    <!-- 企业基本信息--营业信息 -->
    <div class="secondStep form_area">
      <el-form
        :model="extForm"
        ref="ruleForm4"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--营业信息</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册地址："
                prop="subconBaseInfo.registeredAddress"
                :rules="rules4.registeredAddress"
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.registeredAddress"
                  placeholder="请输入注册地址"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 待定 -->
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="办公地址："
                prop="subconBaseInfo.businessAddress"
                :rules="rules4.businessAddress"
                 >
                <el-input
                  v-model="extForm.subconBaseInfo.businessAddress"
                  placeholder="请输入办公地址"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="历史名称："
                >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.historyName"
                  placeholder="请输入历史名称"
                  maxlength="1000"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="币种："
                prop="subconBaseInfo.currencyCode"
                :rules="rules4.currencyCode"
                >
                <!-- <el-input
                  v-model="essentialInformation.currency"
                  placeholder="请输入币种"
                ></el-input> -->
                <el-select
                  v-model="extForm.subconBaseInfo.currencyCode"
                  filterable
                  placeholder="请选择币种"
                  @change="forceUpdate"
                >
                  <el-option
                    v-for="item in qryCurrencyList"
                    :key="item.zcurrencycode"
                    :label="item.zcurrencyname"
                    :value="item.zcurrencycode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="注册资本（万元）："
              >
                <el-input
                  disabled
                  maxlength="20"
                  v-model="extForm.subconBaseInfo.registeredCapital"
                  placeholder="请输入注册资本"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="实缴资本（万元）："
              >
                <el-input
                  disabled
                  maxlength="20"
                  placeholder="请输入实缴资本,仅支持四位小数"
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')"
                  v-model="extForm.subconBaseInfo.actualCapital"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="基本存款账户："
                prop="subconBaseInfo.accountBank"
                :rules="rules4.accountBank"
                >
                <el-input
                  v-model="extForm.subconBaseInfo.accountBank"
                  placeholder="请输入基本存款账户"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="银行账号："
                prop="subconBaseInfo.bankNo"
                :rules="rules4.bankNo"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.bankNo"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  placeholder="请输入银行账号"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="开票地址："
                prop="subconBaseInfo.billingAddress"
                :rules="rules4.billingAddress"
                >
                <el-input
                  v-model="extForm.subconBaseInfo.billingAddress"
                  placeholder="请输入开票地址"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item 
                label-width="190px" 
                label="开票电话：" 
              >
                <el-input
                  v-model="extForm.subconBaseInfo.billingPhone"
                  oninput="value=value.replace(/[^0-9-.]/g,'')"
                  placeholder="请输入开票电话"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="纳税人类型："
                prop="subconBaseInfo.taxpayerType"
                :rules="rules4.taxpayerType"
              >
                <el-select
                  v-model="extForm.subconBaseInfo.taxpayerType"
                  placeholder="请选择"
                >
                  <el-option label="一般纳税人" :value="0"></el-option>
                  <el-option label="小规模纳税人" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px" 
                label="证明："
                :rules="rules4.taxCertificate"
                prop="subconBaseInfo.taxCertificate">
                <upload
                  :uploadUrl="secondFiles.taxCertificate"
                  @uploadUrl="getUrl1"
                ></upload>
                <span style="color: red;position: absolute; top: 24px; right: 60px;">根据税务系统上传开具证明</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="190px" label="公司人数：">
                <el-input
                  v-model="extForm.subconBaseInfo.companySize"
                  placeholder="请输入公司人数"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item 
                label-width="190px" 
                label="参保人数：" 
              >
                <el-input
                  disabled
                  v-model="extForm.subconBaseInfo.socialStaffNum"
                  placeholder="请输入参保人数"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="公司成立时间："
                prop="subconBaseInfo.companySetupTime"
                :rules="rules4.companySetupTime"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.companySetupTime"
                  @change="changePicker3"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="营业期限开始："
                prop="subconBaseInfo.businessStartTime"
                :rules="rules4.businessStartTime"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.businessStartTime"
                  @change="changePicker1"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
             
              <!-- <el-form-item
                label-width="190px"
                label="营业期限："
                prop="businessTime"
                ref="businessTime"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.businessTime"
                  @change="changePicker1"
                  :clearable="false"
                  align="right"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
                <label style="color: red">长期请选择2099年，可输入</label>
              </el-form-item> -->
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="营业期限结束："
                prop="subconBaseInfo.businessEndTime"
                :rules="rules4.businessEndTime"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.businessEndTime"
                  @change="changePicker2"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
                <label style="color: red;height: 20px;display: block;">长期请选择2099年，可输入</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item 
                label-width="190px" 
                label="营业执照发证机关：" 
                prop="subconBaseInfo.issuingAuthority"
                :rules="rules4.issuingAuthority"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.issuingAuthority"
                  placeholder="请输入营业执照发证机关"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                ref="uplodFile4"
                label-width="190px"
                label="营业执照附件："
                :rules="rules4.businessLicenseScan"
                prop="subconBaseInfo.businessLicenseScan"
              >
                <upload
                  :uploadUrl="secondFiles.businessLicense"
                  @uploadUrl="getUrl"
                ></upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="190px"
                label="经营范围："
              >
                <el-input
                  style="width: 730px"
                  type="textarea"
                  :rows="3"
                  v-model="extForm.subconBaseInfo.businessScope"
                  maxlength="3000"
                  placeholder="请输入营业范围"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="addTabIndex">
              <el-form-item
                label-width="190px"
                label="安全许可证有效期起："
                prop="subconBaseInfo.safetyLicenseValidityStart"
                ref="safetyLicenseValidityStart"
                :rules="rules4.safetyLicenseValidityStart"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.safetyLicenseValidityStart"
                  type="date"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                <!--                  @change="safePicker"-->
                <!--                  :clearable="false"-->
                <!--                  align="right"-->
                <!--                  type="daterange"-->
                <!--                  value-format="yyyy-MM-dd"-->
                <!--                  range-separator="至"-->
                <!--                  start-placeholder="开始日期"-->
                <!--                  end-placeholder="结束日期"-->
                <!--                  :picker-options="pickerOptions"-->
                <!--                >-->
                <!--                </el-date-picker>-->
              </el-form-item>
            </el-col>
            <el-col :span="12" class="addTabIndex">
              <el-form-item
                label-width="190px"
                label="安全许可证有效期至："
                prop="subconBaseInfo.safetyLicenseValidityEnd"
                :rules="rules4.safetyLicenseValidityEnd"
              >
                <el-date-picker
                  v-model="extForm.subconBaseInfo.safetyLicenseValidityEnd"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="安全许可证发证机关："
                prop="subconBaseInfo.safetyLicenseIssAuth"
                :rules="rules4.safetyLicenseIssAuth"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.safetyLicenseIssAuth"
                  placeholder="请输入安全许可证发证机关"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item
                label-width="190px"
                label="安全许生产可证编号："
                prop="subconBaseInfo.securityClearanceNumber"
                :rules="rules4.securityClearanceNumber"
              >
                <el-input
                  v-model="extForm.subconBaseInfo.securityClearanceNumber"
                  placeholder="请输入安全生产许可证编号"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                ref="uplodFile5"
                label-width="190px"
                label="安全许可证附件："
                prop="subconBaseInfo.safetyLicenseEnclosure"
                :rules="rules4.safetyLicenseEnclosure"
              >
                <anquan
                  :uploadUrl="secondFiles.SafetyPermits"
                  @anquan="getUrlAq"
                ></anquan>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24" >
              <el-form-item
                label-width="190px"
                label="分包商专业："
                prop="subconSubject"
              >
                <subcontractorSpecialty
                  ref="subcontractorSpecialty"
                  :extTable="extForm.subconSubjectChange"
                ></subcontractorSpecialty>
              </el-form-item>
            </el-col>
          </el-row>-->
        </div>
      </el-form>
    </div>
     <!-- 业务联系人 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="ruleForm5"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--业务联系人</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="subconBusinessRule"
              :mode="extForm.subconBusinessPerson"
              prop="list"
            >
              <marketHistoryList
                :extTable="extForm.subconBusinessPerson"
                ref="subconBusinessPersonRef"
              ></marketHistoryList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 市场主体实控信息 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="ruleForm6"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--市场主体实控信息</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="subconControlsRule"
              :mode="extForm.subconControlsPerson"
              label-width=""
              label=""
              prop="list"
            >
              <marketControlsList
                :extTable="extForm.subconControlsPerson"
                ref="subconControlsPersonRef"
              ></marketControlsList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
    <!-- 市场主体董监高信息 -->
    <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="ruleForm7"
      >
        <div class="title">
          <span></span>
          <div>企业基本信息--市场主体董监高信息</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="subconExecutiveRule"
              :mode="extForm.subconExecutivePerson"
              label-width=""
              label=""
              prop="list"
            >
              <marketDongList
                :extTable="extForm.subconExecutivePerson"
                ref="subconExecutivePersonRef"
              ></marketDongList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
    <!-- 企业基本信息--分包商业务类别 -->
    <div class="secondStep form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="extForm"
        ref="ruleForm8"
      >
      <div class="title">
        <span></span>
          <div>企业基本信息--分包商承揽业务类别</div>
      </div>
      <el-row>
        <el-col :span="24" class="checkbox_area">
          <el-form-item
            label-width="115px"
            label="分包商业务类别："
            :rules="rules5.subconCooProfessionBOS"
            prop="subconCooProfessionList"
          >
          <el-checkbox-group v-model="extForm.subconCooProfessionList">
            <el-checkbox v-for="item in industryCategoryList" :key="item.id" :label="item.id" name="type">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label-width="115px" label="是否融合项目：" :rules="rules5.isJoinMerge">
            <el-radio-group v-model="extForm.subconBaseInfo.isJoinMerge">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="width:1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 资质列表 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="extForm.subconQualificationsAndFilesBO"
        ref="ruleForm11"
      >
        <div class="title">
          <span></span>
          <div>资质列表</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule1"
              :model="extForm.subconQualificationsAndFilesBO.subconQualificationsBOS"
              label-width=""
              label=""
              prop="list"
            >
              <qualificationList
                :extTable="extForm.subconQualificationsAndFilesBO.subconQualificationsBOS"
                ref="qualificationList1"
              ></qualificationList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile6"
              :rules="rules6.subconFileinfoBOS"
              prop="subconFileinfoBOS"
              label-width="110px"
              label="资质证书附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  extForm.subconQualificationsAndFilesBO.subconFileinfoBOS &&
                  extForm.subconQualificationsAndFilesBO.subconFileinfoBOS.length
                    ? extForm.subconQualificationsAndFilesBO.subconFileinfoBOS[0]
                    : ''
                "
                @qualifications="qualifications1"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
    <!-- 财务能力 -->
    <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        ref="ruleForm9"
        :model="extForm.subconBaseInfo"
      >
        <div class="title">
          <span></span>
          <div>财务能力</div>
        </div>
        <!-- <el-row>
          <el-col :span="24" class="addTabIndex deviation form_area">
            <el-form-item
              label-width="81px"
              label="垫资能力："
              prop="advanceFund"
              :rules="rules6.advanceFund"
            >
            <el-input
              type="textarea"
              :rows="3"
              maxlength="100"
              v-model="extForm.subconBaseInfo.advanceFund"
              placeholder="请输入垫资能力"
            ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              label-width=""
              label=""
              prop="list"
              :mode="extForm.subconTyPfe"
              :rules="subconTyPfeRule"
            >
              <financialCapacity
                :extTable="extForm.subconTyPfe"
                ref="financialCapacityRef"
              ></financialCapacity>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width:1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 社会信用 -->
     <div class="secondStep">
      <el-form
        :model="{}"
        :rules="rules7"
        ref="ruleForm10"
        label-width="60px"
        class="demo-ruleForm"
      >
        <div class="title">
          <span></span>
          <div>社会信用</div>
        </div>
        <div class="masterDataInformation">
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="0px"
                label=""
              >
                <creditSituationOne
                  :tableData="extForm.illegalinfoBOS"
                 />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="0px"
                label=""
              >
                <creditSituationTwo
                  :tableData="extForm.dishonestBOS"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label-width="0px"
                label=""
              >
                <creditSituationThree
                  :tableData="extForm.punishmentinfoBOS"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="width: 1196px !important"></el-row>

        </div>
      </el-form>
    </div>
      <!-- 技术人员 -->
      <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="extForm"
        :rules="rules8"
        ref="ruleForm12"
      >
        <div class="title">
          <span></span>
          <div>技术能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation form_area">
            <el-form-item
              label-width="151px"
              label="施工核心技术及特长："
              prop="subconBaseInfo.coreAndExpertise"
              :rules="rules8.coreAndExpertise"
            >
            <el-input
              v-model="extForm.subconBaseInfo.coreAndExpertise"
              type="textarea"
              :rows="3"
              placeholder="请输入施工核心技术及特长"
              maxlength="255"
            ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule2"
              :model="extForm.subconManagePersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <technicalPersonnelInfo
                :extTable="extForm.subconManagePersonAndFilesBO.subconManagePersonBOs"
                ref="qualificationList2"
              ></technicalPersonnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error1"
              label-width="110px"
              label="工程业绩附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.gcyj ? jsryxxFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications2(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error2"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.sbzm ? jsryxxFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications2(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error3"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.ldht ? jsryxxFiles.ldht : ''
                "
                @qualifications="(url) => qualifications2(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule3"
              :model="extForm.subconAwardBOS"
              label-width=""
              label=""
              prop="list"
            >
              <awardsInfo
                :extTable="extForm.subconAwardBOS"
                ref="qualificationList3"
              ></awardsInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 生产能力 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="extForm"
        ref="ruleForm13"
      >
        <div class="title">
          <span></span>
          <div>生产能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule4"
              :model="extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <personnelInfo
                :extTable="extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs"
                tableTitle="持证管理人员"
                ref="qualificationList4"
              ></personnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error4"
              label-width="110px"
              label="工程业绩附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  czglryFiles.gcyj ? czglryFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications3(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error5"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  czglryFiles.sbzm ? czglryFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications3(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error6"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                 czglryFiles.ldht ? czglryFiles.ldht : ''
                "
                @qualifications="(url) => qualifications3(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule5"
              :mode="extForm.subconToDoPersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <personnelInfo
                :extTable="extForm.subconToDoPersonAndFilesBO.subconManagePersonBOs"
                tableTitle="作业班组"
                ref="qualificationList5"
              ></personnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error7"
              label-width="110px"
              label="工程业绩附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.gcyj ? zybzFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications4(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error8"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.sbzm ? zybzFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications4(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error9"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.ldht ? zybzFiles.ldht : ''
                "
                @qualifications="(url) => qualifications4(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule6"
              :mode="extForm.subconProductiveCapacityBOS"
              label-width=""
              label=""
              prop="list"
            >
              <annualProductionCapacity
                :extTable="extForm.subconProductiveCapacityBOS"
                ref="qualificationList6"
              ></annualProductionCapacity>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item prop="list" :model="extForm.subconDeviceInfoPOS"  :rules="qualificationListRule7">
              <majorEquipment
                ref="qualificationList7"
                :extTable="extForm.subconDeviceInfoPOS"
              ></majorEquipment>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile2"
              label-width="82px"
              label="周转材料："
              prop="subconBaseInfo.turnoverMaterial"
              :rules="rules9.turnoverMaterial"
            >
              <qualificationCertificate
                :uploadUrl="thirdFiles.zzcl"
                @qualifications="qualifications5"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item prop="list" :model="extForm.subconContractingCapacityBOS"  :rules="qualificationListRule8">
              <!-- 业务承揽能力 -->
              <businessContractingAbility
                ref="qualificationList8"
                :extTable="extForm.subconContractingCapacityBOS"
              ></businessContractingAbility>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
    <div class="secondStep buttons">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="buttons"
      >
        <el-row style="1195px !important"></el-row>
        <el-form-item>
          <el-button @click="submitForm()">下一步</el-button>
          <el-button class="stopBtn" @click="stopForm()">暂存</el-button>
          <el-button class="lastBtn" @click="lastStep()">上一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="选择企业性质"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <cooperativeUnit
        :treeData="listSubconBaseSubjectList"
        ref="msgFormSon"
      ></cooperativeUnit>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择往来单位类别"
      :visible.sync="categoryDialogVisible"
      width="30%"
      center
    >
      <subconCategoryTree
        :treeData="listSubconCategory"
        ref="msgFormCategory"
      ></subconCategoryTree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="categoryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCategoryTreeItem">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择往来单位性质"
      :visible.sync="natureDialogVisible"
      width="30%"
      center
    >
      <subcon-nature
        :treeData="listSubconNature"
        ref="msgFormNature"
      ></subcon-nature>
      <span slot="footer" class="dialog-footer">
        <el-button @click="natureDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getNatureTreeItem">确 定</el-button>
      </span>
    </el-dialog>
    <approvalRecord v-if="extForm.subconBaseInfo.approvalStatus == '4'" ref="approvalRecord" :businessBillId="extForm.subconBaseInfo.id" />
  </div>
</template>

<script>
import upload from "../components/upload.vue";
import frontPhotoOfIdCard from "../components/frontPhotoOfIdCard.vue";
import reversePhotoOfIdCard from "../components/reversePhotoOfIdCard.vue";
import anquan from "../components/anquan.vue";
import faren from "../components/faren.vue";
import cooperativeUnit from "../components/cooperativeUnit.vue";
import subconCategoryTree from "../components/subconCategoryTree.vue";
import subconNature from "../components/subconNatureTree.vue";
// import upload1 from "../upload.vue";
// 上传附件
import qualificationCertificate from "../components/qualificationCertificate.vue";
// 财务能力
import financialCapacity from "../components/financialCapacity.vue"
// 主要设备
import majorEquipment from "../components/majorEquipment.vue";
// 人员管理
import personnelManagement from "../components/personnelManagement.vue";
// 资历列表
import qualificationList from "../components/qualificationList.vue";
// 技术人员
import technicalPersonnelInfo from "../components/technicalPersonnelInfo.vue";
// 获奖情况
import awardsInfo from "../components/awardsInfo.vue";
// 持证管理人员  作业班组
import personnelInfo from "../components/personnelInfo.vue";
// 年生产能力
import annualProductionCapacity from "../components/annualProductionCapacity.vue";
// 市场主体历史信息
import marketHistoryList from "../components/marketHistoryList.vue";
// 市场主体实控信息
import marketControlsList from "../components/marketControlsList.vue";
// 市场主体董监高信息
import marketDongList from "../components/marketDongList.vue";
// 业务承揽能力
import businessContractingAbility from "../components/businessContractingAbility.vue";
//
import scmaAreaSelector from "../components/scmaAreaSelector";
//
import regionConfig from "../mixins/regionConfig";
// 企业违法行为
import creditSituationOne from "../components/creditSituationOne.vue";
// 失信被执行人情况
import creditSituationTwo from "../components/creditSituationTwo.vue";
// 其他不良信息
import creditSituationThree from "../components/creditSituationThree.vue";
// 审批记录
import approvalRecord from "../components/approvalRecord.vue";
// 分包商专业
// import subcontractorSpecialty from "../components/subcontractorSpecialty.vue";
// 手动上传
// 接口总览
import {
  getCountryList,
  getAdministrationList,
  // findAreaAddress,
  listSubconCategory,
  listSubconNature,
  listSubconUnitNaturePage,
  qryCurrencyType,
  checkIsInternalUnit,
  dealSubconRegister,
  getSubconConfigByCode,
} from "@/api/subcontractor-register";
export default {
  mixins: [regionConfig],
  props: {
    extForm: {},
    secondFiles: {
      idFront: null,  // 身份证正面
      idBack: null,  // 身份证反面
      legalRepresentative: null,  // 法人授权委托书
      businessLicense: null,  // 营业执照
      SafetyPermits: null,  // 安全许可证
      taxCertificate: null,  // 纳税类型证明
    },
    industryCategoryList: {
      type: Array,
      default: []
    }
  },
  components: {
    upload,
    majorEquipment,
    financialCapacity,
    personnelManagement,
    qualificationList,
    technicalPersonnelInfo,
    awardsInfo,
    personnelInfo,
    annualProductionCapacity,
    marketControlsList,
    marketHistoryList,
    marketDongList,
    qualificationCertificate,
    // subcontractorSpecialty,
    frontPhotoOfIdCard,
    reversePhotoOfIdCard,
    cooperativeUnit,
    anquan,
    faren,
    subconCategoryTree,
    subconNature,
    scmaAreaSelector,
    businessContractingAbility,
    creditSituationOne,
    creditSituationTwo,
    creditSituationThree,
    approvalRecord
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
    pickerOptions1() {
      return {
        disabledDate: function(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      };
    }
  },
  mounted() {
    // this.extForm.subconBaseInfo.registeredCapital=this.extForm.subconBaseInfo.registeredCapital.replace(/[^0-9.]/g,'')
    this.checkIsInternalUnit();
    if (!this.extForm.subconBaseInfo.currencyCode) {
      this.extForm.subconBaseInfo.currencyCode = "156";
      this.extForm.subconBaseInfo.currency = "人民币元"
    }
    if (this.extForm.subconAuthAccountInfo.cardType === undefined) {
      this.extForm.subconAuthAccountInfo.cardType = 0;
    }
    if (this.extForm.subconBaseInfo.cardType === undefined) {
      this.extForm.subconBaseInfo.cardType = 0;
    }
    // 往来单位类别
    listSubconCategory({
      business: "",
      attribute1: true,
      isDelete: 0,
      baseAppId: 100065
      // lastStatus: 1
    }).then(res => {
      if (res.data.code === "0") {
        this.listSubconCategory = res.data.data;
      }
    });
    // 往来单位性质
    listSubconNature({
      business: "",
      attribute1: true,
      isDelete: 0,
      baseAppId: 100065,
      lastStatus: 1
    }).then(res => {
      if (res.data.code === "0") {
        this.listSubconNature = res.data.data;
      }
    });
    this.$refs.myCascader.inputValue = this.extForm.subconBaseInfo
      ? this.extForm.subconBaseInfo.inputValue
      : "";
    // 企业性质
    listSubconUnitNaturePage({
      attribute1: "true",
      baseAppId: 100065,
      business: "",
      isDelete: 0
    }).then(res => {
      this.listSubconBaseSubjectList = res.data.data;
    });

    // 币种
    qryCurrencyType({
      pageNo: 1,
      pageSize: 1000
    }).then(res => {
      this.qryCurrencyList = res.data.data.rows;
      this.extForm.subconBaseInfo.currencyCode = "156";
    });
    // 授权书模板id
    getSubconConfigByCode({ configCode: "01" }).then(res => {
      this.uploadId = res.data.data.configValue;
    });
    // this.handleCountry();
    this.setProfessionList();
  },
  created(){
    this.setFiles1();
    this.setFiles2();
  },
  methods: {
    setProfessionList(){
      let subconCooProfessionBOS = this.extForm.subconCooProfessionBOS.map(item => item.professionId)
      this.$set(this.extForm, "subconCooProfessionList" ,subconCooProfessionBOS)
    },
    setFiles1(){
      if(this.extForm.subconBaseFileinfoBOS && this.extForm.subconBaseFileinfoBOS.length > 0){
        let files = this.extForm.subconBaseFileinfoBOS
        files.forEach(item => {
          switch (item.businessFileType){
            case "1":
              this.secondFiles.idFront = item;
              break;
            case "2":
              this.secondFiles.idBack = item;
              break;
            case "12":
              this.secondFiles.legalRepresentative = item;
              break;
            case "3":
              this.secondFiles.businessLicense = item;
              break;
            case "4":
              this.secondFiles.SafetyPermits = item;
              break;
            case "25":
              this.secondFiles.taxCertificate = item;
              break;  
          }
        })
      }
    },
    showApprovalRecord() {
      this.$refs.approvalRecord.ARdialogVisible = true;
    },
    // 是否内部单位
    checkIsInternalUnit() {
      checkIsInternalUnit({
        unifiedCreditCode: this.extForm.subconBaseInfo.unifiedCreditCode,
      }).then( res => {
          if (res.data.code === "0") {
            this.extForm.subconBaseInfo.yesNo = res.data.data.changeInfoId;
          }
        });
    },
    handleCountry() {
      this.defaultArea = [];
      var tmp = this.extForm.subconBaseInfo.inputValue.split("/");
      for (let i = 0; i < this.extForm.subconBaseInfo.countrys.length; i++) {
        try {
          this.defaultArea.push({
            level: i + 1,
            name: tmp[i],
            code: this.extForm.subconBaseInfo.countrys[i]
          });
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    // 往来单位性质 修改
    getCategoryCode(val) {
      this.extForm.subconBaseInfo.subconCategoryCode = val;
      this.listSubconCategory.forEach(item => {
        if (item.categoryCode === val) {
          this.extForm.subconBaseInfo.subconCategoryName = item.name;
        }
      });
    },
    getNatureCode(val) {
      this.extForm.subconBaseInfo.subconNatureCode = val;
      this.listSubconNature.forEach(item => {
        if (item.natureCode === val) {
          this.extForm.subconBaseInfo.subconNatureName = item.name;
        }
      });
    },
    industryCategoryChange() {
      let bos = [];
      if(this.extForm.subconCooProfessionList.length > 0){
        this.industryCategoryList.forEach(item1 => {
          this.extForm.subconCooProfessionList.forEach(item2 => {
            if(item1.id == item2){
              let ele = {};
              if(this.extForm.subconCooProfessionBOS.length > 0){
                let arr = this.extForm.subconCooProfessionBOS.filter(item3 => item3.professionId == item2);
                if(arr.length > 0){
                  ele = {
                    professionName: item1.name,
                    professionId: item1.id,
                    subconCooSubjectBOS: arr[0].subconCooSubjectBOS,
                    attribute2: arr[0].attribute2
                  }
                }else {
                  ele = {
                    professionName: item1.name,
                    professionId: item1.id,
                    subconCooSubjectBOS: [],
                    attribute2: ""
                  }
                }
              }else {
                ele = {
                  professionName: item1.name,
                  professionId: item1.id,
                  subconCooSubjectBOS: [],
                  attribute2: ""
                }
              }
              bos.push(ele);
            }
          })
        })
      }
      return bos
    },
    getTreeItem() {
      let treeItem = this.$refs["msgFormSon"].subjectObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconBaseInfo, "comNatureName", "");
      this.$set(
        this.extForm.subconBaseInfo,
        "comNatureCode",
        treeItem.natureCode
      );
      this.$set(this.extForm.subconBaseInfo, "comNatureName", treeItem.name);
      this.centerDialogVisible = false;
    },
    getCategoryTreeItem() {
      let treeItem = this.$refs["msgFormCategory"].categoryObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconBaseInfo, "subconCategoryName", "");
      this.$set(
        this.extForm.subconBaseInfo,
        "subconCategoryCode",
        treeItem.categoryCode
      );
      this.$set(
        this.extForm.subconBaseInfo,
        "subconCategoryName",
        treeItem.name
      );
      this.categoryDialogVisible = false;
    },
    getNatureTreeItem() {
      let treeItem = this.$refs["msgFormNature"].natureObj;
      if (!treeItem || (treeItem && treeItem.lastStatus !== 1)) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点以及下级节点数据,并且是末级数据",
          ccuiCustom: true
        });
        return false;
      }
      this.$set(this.extForm.subconBaseInfo, "subconNatureName", "");
      this.$set(
        this.extForm.subconBaseInfo,
        "subconNatureCode",
        treeItem.natureCode
      );
      this.$set(
        this.extForm.subconBaseInfo,
        "subconNatureName",
        treeItem.name
      );
      this.natureDialogVisible = false;
    },
    getUrl(url) {
      if(url){
        this.secondFiles.businessLicense = url;
        this.extForm.subconBaseInfo.businessLicenseScan = url.uploadId;
        this.$refs.uplodFile4.clearValidate()
      }else {
        this.secondFiles.businessLicense = null;
        this.extForm.subconBaseInfo.businessLicenseScan = "";
      }
     
    },
    getUrl1(url) {
      if(url){
        this.secondFiles.taxCertificate = url;
        this.extForm.subconBaseInfo.taxCertificate = url.uploadId;
        this.$refs.uplodFile4.clearValidate()
      }else {
        this.secondFiles.taxCertificate = null;
        this.extForm.subconBaseInfo.taxCertificate = "";
      }
    },
    getUrlZm(url) {
      if(url){
        this.secondFiles.idFront = url;
        this.extForm.subconBaseInfo.legalPersonCardFront = url.uploadId;
        this.$refs.uplodFile1.clearValidate()
      }else {
        this.secondFiles.idFront = null;
        this.extForm.subconBaseInfo.legalPersonCardFront = "";
      }
    },
    getUrlFm(url) {
      if(url){
        this.secondFiles.idBack = url;
        this.extForm.subconBaseInfo.legalPersonCardBack = url.uploadId;
        this.$refs.uplodFile2.clearValidate()
      }else {
        this.secondFiles.idBack = null;
        this.extForm.subconBaseInfo.legalPersonCardBack = "";
      }
    },
    getUrlFr(url) {
      if(url){
        this.secondFiles.legalRepresentative = url;
        this.extForm.subconAuthAccountInfo.authCertificate = url.uploadId;
        this.$refs.uplodFile3.clearValidate()
      }else {
        this.secondFiles.legalRepresentative = null;
        this.extForm.subconAuthAccountInfo.authCertificate = "";
      }
    },
    forceUpdate(value) {
      let obj = {};
      obj = this.qryCurrencyList.find(item => {
        return item.zcurrencycode === value;
      });
      this.extForm.subconBaseInfo.currency = obj.zcurrencyname;
    },
    download() {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.downloadUrl}?uploadId=` + this.uploadId; //4106
      openUrl.setAttribute("download", "授权委托书");
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    qualifications(url) {
      if (
        this.extForm.subconQualificationsChange &&
        this.extForm.subconQualificationsChange.length <= 0
      ) {
        this.extForm.subconQualificationsChange.push({
          id: 1
        });
      }
      this.extForm.subconQualificationsChange[0].qualificationEnclosure = url;
      this.extForm.subconQualificationsChange[0].attribute10 = url;
    },
    qualifications1(url) {
      if (
        this.extForm.subconQualificationsAndFilesBO.subconQualificationsBOS &&
        this.extForm.subconQualificationsAndFilesBO.subconQualificationsBOS.length <= 0
      ) {
        this.extForm.subconQualificationsAndFilesBO.subconQualificationsBOS.push({
          id: 1
        });
      }
      if(url){
        this.extForm.subconQualificationsAndFilesBO.subconFileinfoBOS[0] = url;
        this.$refs.uplodFile6.clearValidate()
      }else {
        this.extForm.subconQualificationsAndFilesBO.subconFileinfoBOS = []
      }
    },
    qualifications2(url, flag) {
      if (
        this.extForm.subconManagePersonAndFilesBO.subconManagePersonBOs &&
        this.extForm.subconManagePersonAndFilesBO.subconManagePersonBOs.length <= 0
      ) {
        this.extForm.subconManagePersonAndFilesBO.subconManagePersonBOs.push({
          id: 1,
          attribute1: "04"
        });
      }
      if(flag == 1){
        if(url){
          url.businessFileType = "16"
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url);
          this.jsryxxFiles.gcyj = url;
          this.gcyjValid1();
        }else {
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "16")
          this.jsryxxFiles.gcyj = null;
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "15"
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url)
          this.jsryxxFiles.sbzm = url;
          this.gcyjValid2();
        }else {
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "15")
          this.jsryxxFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "14"
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url);
          this.jsryxxFiles.ldht = url;
          this.gcyjValid3();
        }else {
          this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "14")
          this.jsryxxFiles.ldht = null;
        }
      }
    },
    qualifications3(url, flag) {
      if (
        this.extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs &&
        this.extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.length <= 0
      ) {
        this.extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.push({
          id: 1,
          attribute1: "05"
        });
      }
      // this.extForm.subconQualificationsChange[0].qualificationEnclosure = url;
      if(flag == 1){
        if(url){
          url.businessFileType = "21"
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.czglryFiles.gcyj = url
          this.gcyjValid4();
        }else {
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "21")
          this.czglryFiles.gcyj = null
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "20"
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.czglryFiles.sbzm = url
          this.gcyjValid5();
        }else {
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "20")
          this.czglryFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "19"
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.czglryFiles.ldht = url
          this.gcyjValid6();
        }else {
          this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "19")
          this.czglryFiles.ldht = null
        }
      }
    },
    qualifications4(url, flag) {
      if (
        this.extForm.productionCapacity.operatives &&
        this.extForm.productionCapacity.operatives.length <= 0
      ) {
        this.extForm.productionCapacity.operatives.push({
          id: 1,
          attribute1: "06"
        });
      }
      if(flag == 1){
        if(url){
          url.businessFileType = "24"
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.zybzFiles.gcyj = url
          this.gcyjValid7();
        }else {
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "24")
          this.zybzFiles.gcyj = null;
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "23"
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.zybzFiles.sbzm = url
          this.gcyjValid8();
        }else {
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "23")
          this.zybzFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "22"
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.zybzFiles.ldht = url
          this.gcyjValid9();
        }else {
          this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "22")
          this.zybzFiles.ldht = null;
        }
      }
    },
    qualifications5(url) {
      if (
        this.extForm.subconDeviceInfoChange &&
        this.extForm.subconDeviceInfoChange.length <= 0
      ) {
        this.extForm.subconDeviceInfoChange.push({
          id: 1
        });
      }
      if(url) {
        this.thirdFiles.zzcl = url
        this.extForm.subconBaseInfo.turnoverMaterial = url.uploadId;
        this.$refs.uplodFile2.clearValidate()
      }else {
        this.thirdFiles.zzcl = null
        this.extForm.subconBaseInfo.turnoverMaterial = "";
      }
    },
    deviceFile(url) {
      if (
        this.extForm.subconDeviceInfoChange &&
        this.extForm.subconDeviceInfoChange.length <= 0
      ) {
        this.extForm.subconDeviceInfoChange.push({
          id: 1
        });
      }
      this.extForm.subconDeviceInfoChange[0].attribute5 = url;
      this.extForm.subconDeviceInfoChange[0].attribute10 = url;
    },
    getUrlAq(url) {
      if(url) {
        this.secondFiles.SafetyPermits = url;
        this.extForm.subconBaseInfo.safetyLicenseEnclosure = url.uploadId;
        this.$refs.uplodFile5.clearValidate()
      }else {
        this.secondFiles.SafetyPermits = null;
        this.extForm.subconBaseInfo.safetyLicenseEnclosure = "";
      }
    },
    // 暂存
    stopForm() {
      console.log(this.extForm)
      this.extForm.subconCooProfessionBOS = this.industryCategoryChange();
      const tmpObj = Object.assign({}, this.extForm.subconBaseInfo);
      tmpObj.actualCapital = Number(tmpObj.actualCapital);
      tmpObj.updateTime = "";
      tmpObj.legalPersonCardFront = this.extForm.subconBaseInfo
        .legalPersonCardFront
        ? this.extForm.subconBaseInfo.legalPersonCardFront
        : "";
      tmpObj.legalPersonCardBack = this.extForm.subconBaseInfo
        .legalPersonCardBack
        ? this.extForm.subconBaseInfo.legalPersonCardBack
        : "";
      tmpObj.safetyLicenseEnclosure = this.extForm.subconBaseInfo
        .safetyLicenseEnclosure
        ? this.extForm.subconBaseInfo.safetyLicenseEnclosure
        : "";
      tmpObj.businessLicenseScan = this.extForm.subconBaseInfo.businessLicenseScan ? this.extForm.subconBaseInfo.businessLicenseScan : ""
      //业务联系人
      var personnelBusinessList = [];
      if (
        this.extForm.subconBusinessPerson &&
        this.extForm.subconBusinessPerson.length > 0
      ) {
        this.extForm.subconBusinessPerson.forEach(e => {
          var current = Object.assign({}, e);
          personnelBusinessList.push(current);
        });
      }
      //市场主体实控信息
      var personnelControlsList = [];
      if (
        this.extForm.subconControlsPerson &&
        this.extForm.subconControlsPerson.length > 0
      ) {
        this.extForm.subconControlsPerson.forEach(e => {
          var current = Object.assign({}, e);
          console.log('dsadas',current);

          this.qualification.forEach(e => {
            if (current.post == e.attribute2) {
              current.attribute2 = e.attribute2;
              current.post = e.post;
            }
          });
          personnelControlsList.push(current);
        });
      }
      //市场主体董监高信息
      var personnelExecutiveList = [];
      if (
        this.extForm.subconExecutivePerson &&
        this.extForm.subconExecutivePerson.length > 0
      ) {
        this.extForm.subconExecutivePerson.forEach(e => {
          var current = Object.assign({}, e);
          this.qualifiLevels.forEach(e => {
            if (current.post == e.attribute2) {
              current.attribute2 = e.attribute2;
              current.post = e.post;
            }
          });
          personnelExecutiveList.push(current);
        });
      }
      this.extForm.subconAuthAccountInfo.createTime = "";
      this.extForm.subconAuthAccountInfo.updateTime = "";

      var tmpObj1 = Object.assign({}, this.extForm.subconAuthAccountInfo);
      tmpObj.createTime = "";
      tmpObj.updateTime = "";

      if (sessionStorage.getItem("type") === null) {
        tmpObj1.attribute10 = "";
      } else {
        tmpObj1.attribute10 = sessionStorage.getItem("type");
      }
      this.formLoading = true;
      dealSubconRegister({
        type: "1",
        subFlag: "0",
        checkState: 2,
        subconAuthAccountInfoBO: tmpObj1,
        subconBaseInfoBO: tmpObj,
        // 初始合作单位,初始准入单位
        subconCooUnitInfoBO: this.extForm.subconCooUnitInfo,
        //业务联系人
        subconBusinessPersonBOs: personnelBusinessList,
        //市场主体实控信息
        subconControlsPersonBOs: personnelControlsList,
        //市场主体董监高信息
        subconExecutivePersonBOs: personnelExecutiveList,
        // 分包商业务类别
        subconCooProfessionBOS: this.extForm.subconCooProfessionBOS,
        // 财务能力
        subconTyPfeBOS: this.extForm.subconTyPfe,
        // 资质情况
        subconQualificationsAndFilesBO: this.extForm.subconQualificationsAndFilesBO,
        // 技术能力
        subconManagePersonAndFilesBO: this.extForm.subconManagePersonAndFilesBO,
        // 获奖情况
        subconAwardBOS: this.extForm.subconAwardBOS,
        // 持证管理人员
        subconcertificatedPersonAndFilesBO: this.extForm.subconcertificatedPersonAndFilesBO,
        // 作业班组
        subconToDoPersonAndFilesBO: this.extForm.subconToDoPersonAndFilesBO,
        // 年生产能力
        subconProductiveCapacityBOS: this.extForm.subconProductiveCapacityBOS,
        // 主要设备
        subconDeviceInfoBOS: this.extForm.subconDeviceInfoPOS,
        // 业务承揽能力
        subconContractingCapacityBOS: this.extForm.subconContractingCapacityBOS,
      }).then(
        res => {
          this.formLoading = false;
          if (res.data.code === "0") {
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.message,
              ccuiCustom: true
            });
          }
          sessionStorage.removeItem("type");
        },
        error => {
          this.formLoading = false;
        }
      );
    },
    // 下一步
    submitForm() {
      // 校验有效期时间
      if (
        this.extForm.subconBaseInfo.legalPersonCardValidityEnd &&
        new Date().getTime() >=
          new Date(
            this.extForm.subconBaseInfo.legalPersonCardValidityEnd
          ).getTime()
      ) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "法人证件号有效期无效",
          ccuiCustom: true
        });
        return false;
      }
      if (
        this.extForm.subconBaseInfo.businessEndTime &&
        new Date().getTime() >=
          new Date(this.extForm.subconBaseInfo.businessEndTime).getTime()
      ) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "营业期限有效期无效",
          ccuiCustom: true
        });
        this.$refs.businessTime.$el.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
        return false;
      }
      if (
        this.extForm.subconBaseInfo.safetyLicenseValidityEnd &&
        new Date().getTime() >=
          new Date(
            this.extForm.subconBaseInfo.safetyLicenseValidityEnd
          ).getTime()
      ) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "安全生产许可证有效期无效",
          ccuiCustom: true
        });
        this.$refs.safetyLicenseValidityStart.$el.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
        return false;
      }

      this.$refs.subconBusinessPersonRef.ruleFun();  // 业务联系人
      this.$refs.subconControlsPersonRef.ruleFun();  // 市场实控主体
      this.$refs.subconExecutivePersonRef.ruleFun();  // 董监高信息
      this.$refs.financialCapacityRef.ruleFun();  // 财务能力
      this.$refs.qualificationList1.ruleFun();  // 资质列表
      this.$refs.qualificationList2.ruleFun();  // 技术人员
      this.$refs.qualificationList3.ruleFun();  // 获奖情况
      this.$refs.qualificationList4.ruleFun();  // 持证管理人员
      this.$refs.qualificationList5.ruleFun();  // 作业班组
      this.$refs.qualificationList6.ruleFun();  // 年生产能力
      this.$refs.qualificationList7.ruleFun();  // 主要设备
      this.$refs.qualificationList8.ruleFun();  // 业务承揽能力
        const p1 = new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate(valid => {
            if (this.inputValueValid1() && valid) {
              this.formTip.flag1 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag1 = false;
              return false
            }
          });
        });
        const p2 = new Promise((resolve, reject) => {
          this.$refs["ruleForm2"].validate(valid => {
            if (valid) {
              this.formTip.flag2 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag2 = false;
            }
          });
        });
        const p3 = new Promise((resolve, reject) => {
          this.$refs["ruleForm3"].validate(valid => {
            if (valid) {
              this.formTip.flag3 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag3 = false;
            }
          });
        });
        const p4 = new Promise((resolve, reject) => {
          this.$refs["ruleForm4"].validate(valid => {
            if (valid) {
              this.formTip.flag4 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag4 = false;
            }
          });
        });
        const p5 = new Promise((resolve, reject) => {
          this.$refs["ruleForm5"].validate(valid => {
            if (valid) {
              this.formTip.flag5 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag5 = false;
            }
          });
        });
        const p6 = new Promise((resolve, reject) => {
          this.$refs["ruleForm6"].validate(valid => {
            if (valid) {
              this.formTip.flag6 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag6 = false;
            }
          });
        });
         const p7 = new Promise((resolve, reject) => {
          this.$refs["ruleForm7"].validate(valid => {
            if (valid) {
              this.formTip.flag7 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag7 = false;
            }
          });
        });
        const p8 = new Promise((resolve, reject) => {
          this.$refs["ruleForm8"].validate(valid => {
            if (valid) {
              this.formTip.flag8 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag8 = false;
            }
          });
        });
        const p9 = new Promise((resolve, reject) => {
          this.$refs["ruleForm9"].validate(valid => {
            if (valid) {
              this.formTip.flag9 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag9 = false;
            }
          });
        });
        const p10 = new Promise((resolve, reject) => {
          this.$refs["ruleForm10"].validate(valid => {
            if (valid) {
              this.formTip.flag10 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag10 = false;
            }
          });
        });
        const p11 = new Promise((resolve, reject) => {
          this.$refs.ruleForm11.validate(valid => {
            if (valid) {
              this.formTip.flag11 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag11 = false;
              return false
            }
          });
        });
        const p12 = new Promise((resolve, reject) => {
          this.$refs.ruleForm12.validate(valid => {
            let valid1 = this.gcyjValid1();
            let valid2 = this.gcyjValid2();
            let valid3 = this.gcyjValid3();
            if (valid1 && valid2 && valid2 && valid) {
              this.formTip.flag12 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag12 = false;
              return false
            }
          });
        });
        const p13 = new Promise((resolve, reject) => {
          this.$refs.ruleForm13.validate(valid => {
            let valid4 = this.gcyjValid4();
            let valid5 = this.gcyjValid5();
            let valid6 = this.gcyjValid6();
            let valid7 = this.gcyjValid7();
            let valid8 = this.gcyjValid8();
            let valid9 = this.gcyjValid9();
            if (valid4 && valid5 && valid6 && valid7 && valid8 && valid9 && valid) {
              this.formTip.flag13 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag13 = false;
              return false
            }
          });
        });
        let { flag1, flag2, flag3, flag4, flag5, flag6, flag7, flag8, flag9, flag10, flag11, flag12, flag13} = this.formTip;
        if (!flag1 || !flag2 || !flag3 || !flag4 || !flag5 || !flag6 || !flag7 || !flag8 || !flag9 || !flag10 || !flag11 || !flag12 || !flag13) {
          this.$emit("open");
        }else {
          if (this.extForm.subconBusinessPerson.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "业务联系人列表不能为空",
              ccuiCustom: true
            });
            this.$refs.subconBusinessPersonRef.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconControlsPerson.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "市场主体实控信息列表不能为空",
              ccuiCustom: true
            });
            this.$refs.subconControlsPersonRef.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconExecutivePerson.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "市场主体董监高信息列表不能为空",
              ccuiCustom: true
            });
            this.$refs.subconExecutivePersonRef.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconQualificationsAndFilesBO.subconQualificationsBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "资质列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList1.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconTyPfe.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "财务能力列表不能为空",
              ccuiCustom: true
            });
            this.$refs.financialCapacityRef.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconManagePersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "技术人员信息列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList2.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconAwardBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "获奖情况列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList3.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "持证管理人员列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList4.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconToDoPersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "作业班组列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList5.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconProductiveCapacityBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "年生产能力列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList6.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconDeviceInfoPOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "主要设备列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList7.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.extForm.subconContractingCapacityBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "业务承揽能力",
              ccuiCustom: true
            });
            this.$refs.qualificationList8.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.$refs.subconBusinessPersonRef.checkOut&&
            this.$refs.subconControlsPersonRef.checkOut&&
            this.$refs.subconExecutivePersonRef.checkOut&&
            this.$refs.qualificationList1.checkOut&&
            this.$refs.financialCapacityRef.checkOut&&
            this.$refs.qualificationList2.checkOut&&
            this.$refs.qualificationList3.checkOut&&
            this.$refs.qualificationList4.checkOut&&
            this.$refs.qualificationList5.checkOut&&
            this.$refs.qualificationList6.checkOut&&
            this.$refs.qualificationList7.checkOut&&
            this.$refs.qualificationList8.checkOut){
            Promise.all([p1, p2, p3, p4, p5, p6 ,p7, p8, p9, p10, p11, p12, p13]).then(async () => {
              this.extForm.subconCooProfessionBOS = this.industryCategoryChange();
              const tmpObj = Object.assign({}, this.extForm.subconBaseInfo);
              tmpObj.actualCapital = Number(tmpObj.actualCapital);
              tmpObj.createTime = "";
              tmpObj.updateTime = "";
              tmpObj.checkState = 2;
              tmpObj.registeredType = 0;
              tmpObj.legalPersonCardFront = this.extForm.subconBaseInfo.legalPersonCardFront;
              tmpObj.legalPersonCardBack = this.extForm.subconBaseInfo.legalPersonCardBack;
              tmpObj.safetyLicenseEnclosure = this.extForm.subconBaseInfo.safetyLicenseEnclosure;
              tmpObj.businessLicenseScan = this.extForm.subconBaseInfo.businessLicenseScan;
              //业务联系人
              var personnelBusinessList = [];
              if (
                this.extForm.subconBusinessPerson &&
                this.extForm.subconBusinessPerson.length > 0
              ) {
                this.extForm.subconBusinessPerson.forEach(e => {
                  var current = Object.assign({}, e);
                  personnelBusinessList.push(current);
                });
              }
              //市场主体实控信息
              var personnelControlsList = [];
              if (
                this.extForm.subconControlsPerson &&
                this.extForm.subconControlsPerson.length > 0
              ) {
                this.extForm.subconControlsPerson.forEach(e => {
                  var current = Object.assign({}, e);
                  this.qualification.forEach(e => {
                    if (current.post == e.attribute2) {
                      current.attribute2 = e.attribute2;
                      current.post = e.post;
                    }
                  });
                  personnelControlsList.push(current);
                });
              }
              //市场主体董监高信息
              var personnelExecutiveList = [];
              if (
                this.extForm.subconExecutivePerson &&
                this.extForm.subconExecutivePerson.length > 0
              ) {
                this.extForm.subconExecutivePerson.forEach(e => {
                  var current = Object.assign({}, e);
                  this.qualifiLevels.forEach(e => {
                    if (current.post == e.attribute2) {
                      current.attribute2 = e.attribute2;
                      current.post = e.post;
                    }
                  });
                  personnelExecutiveList.push(current);
                });
              }
              this.extForm.subconAuthAccountInfo.createTime = "";

              this.extForm.subconAuthAccountInfo.updateTime = "";

              var tmpObj1 = Object.assign({}, this.extForm.subconAuthAccountInfo);

              this.formLoading = true;
              dealSubconRegister({
                type: "1",
                subFlag: "1",
                checkState: 2,
                subconAuthAccountInfoBO: tmpObj1,
                subconBaseInfoBO: tmpObj,
                // 初始合作单位,初始准入单位
                subconCooUnitInfoBO: this.extForm.subconCooUnitInfo,
                //业务联系人
                subconBusinessPersonBOs: personnelBusinessList,
                //市场主体实控信息
                subconControlsPersonBOs: personnelControlsList,
                //市场主体董监高信息
                subconExecutivePersonBOs: personnelExecutiveList,
                // 分包商业务类别
                subconCooProfessionBOS: this.extForm.subconCooProfessionBOS,
                // 财务能力
                subconTyPfeBOS: this.extForm.subconTyPfe,
                // 资质情况
                subconQualificationsAndFilesBO: this.extForm.subconQualificationsAndFilesBO,
                // 技术人员
                subconManagePersonAndFilesBO: this.extForm.subconManagePersonAndFilesBO,
                // 获奖情况
                subconAwardBOS: this.extForm.subconAwardBOS,
                 // 持证管理人员
                subconcertificatedPersonAndFilesBO: this.extForm.subconcertificatedPersonAndFilesBO,
                // 作业班组
                subconToDoPersonAndFilesBO: this.extForm.subconToDoPersonAndFilesBO,
                // 年生产能力
                subconProductiveCapacityBOS: this.extForm.subconProductiveCapacityBOS,
                // 主要设备
                subconDeviceInfoBOS: this.extForm.subconDeviceInfoPOS,
                // 业务承揽能力
                subconContractingCapacityBOS: this.extForm.subconContractingCapacityBOS,
              })
                .then(res => {
                  let { code, message } = res.data;
                  console.log("返回结果" + JSON.stringify(res.data));
                  if (res.data.code === "0") {
                    this.$emit("getStep", 2);
                  } else {
                    this.$message({
                      message: message,
                      type: code === "0" ? "success" : "error"
                    });
                  }
                  this.formLoading = false;
                })
                .catch(e => {
                  this.formLoading = false;
                  console.log(e);
                });
            });
          }
        }






      // let that = this;

    },

    // 上一步
    lastStep() {
      this.$confirm("如需跳转上一步！则会刷新数据", "确认跳转", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          location.reload();
        })
        .catch(action => {});
    },

    // 获取省级联动数据
    handleChange(val) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue();
        });
      }, 100);
    },
    getLabelValue() {
      this.extForm.subconBaseInfo.province = "";
      this.extForm.subconBaseInfo.city = "";
      this.extForm.subconBaseInfo.county = "";
      this.extForm.subconBaseInfo.attribute2 = "";
      const obj = this.$refs["myCascader"].getCheckedNodes();
      this.extForm.subconBaseInfo.country = obj[0].pathLabels[0];
      this.extForm.subconBaseInfo.province = obj[0].pathLabels[1];
      this.extForm.subconBaseInfo.city = obj[0].pathLabels[2];
      this.extForm.subconBaseInfo.county = obj[0].pathLabels[3];
      this.extForm.subconBaseInfo.attribute2 = JSON.stringify(obj[0].path);
    },
    // 获取省级联动数据 结束

    safePicker(date) {
      if (date) {
        this.extForm.subconBaseInfo.safetyLicenseValidityStart = this.getDate(
          date[0]
        );
        this.extForm.subconBaseInfo.safetyLicenseValidityEnd = this.getDate(
          date[1]
        );
      }
    },
    changePicker(date) {
      if (date) {
        this.extForm.subconBaseInfo.legalPersonCardValidityStart = this.getDate(
          date[0]
        );
        this.extForm.subconBaseInfo.legalPersonCardValidityEnd = this.getDate(
          date[1]
        );
      }
    },
    changePicker1(date) {
      if (date) {
        this.extForm.subconBaseInfo.businessStartTime = date;
      }
    },
    changePicker2(date) {
      if (date) {
        this.extForm.subconBaseInfo.businessEndTime = date;
      }
    },
    changePicker3(date) {
      if (date) {
        this.extForm.subconBaseInfo.companySetupTime = date;
      }
    },

    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    inputValueValid1() {
      if(!this.extForm.subconBaseInfo.inputValue){
        this.errorTips1 = "请选择所在地"
        return false
      }else {
        this.errorTips1 = ""
        return true
      }
    },
    // 附件校验
    gcyjValid1() {
      if(!this.jsryxxFiles.gcyj){
        this.error1 = "工程业绩附件不能为空"
        return false
      }else {
        this.error1 = ""
        return true
      }
    },
    gcyjValid2() {
      if(!this.jsryxxFiles.sbzm){
        this.error2 = "社保证明附件不能为空"
        return false
      }else {
        this.error2 = ""
        return true
      }
    },
    gcyjValid3() {
      if(!this.jsryxxFiles.ldht){
        this.error3 = "工程业绩附件不能为空"
        return false
      }else {
        this.error3 = ""
        return true
      }
    },
    gcyjValid4() {
      if(!this.czglryFiles.gcyj){
        this.error4 = "工程业绩附件不能为空"
        return false
      }else {
        this.error4 = ""
        return true
      }
    },
    gcyjValid5() {
      if(!this.czglryFiles.sbzm){
        this.error5 = "社保证明附件不能为空"
        return false
      }else {
        this.error5 = ""
        return true
      }
    },
    gcyjValid6() {
      if(!this.czglryFiles.ldht){
        this.error6 = "工程业绩附件不能为空"
        return false
      }else {
        this.error6 = ""
        return true
      }
    },
    gcyjValid7() {
      if(!this.zybzFiles.gcyj){
        this.error7 = "工程业绩附件不能为空"
        return false
      }else {
        this.error7 = ""
        return true
      }
    },
    gcyjValid8() {
      if(!this.zybzFiles.sbzm){
        this.error8 = "社保证明附件不能为空"
        return false
      }else {
        this.error8 = ""
        return true
      }
    },
    gcyjValid9() {
      if(!this.zybzFiles.ldht){
        this.error9 = "工程业绩附件不能为空"
        return false
      }else {
        this.error9 = ""
        return true
      }
    },
    setFiles2(){
      let files = this.extForm.subconBaseFileinfoBOS
      files.forEach(item => {
        switch (item.businessFileType){
          case "18":
            this.thirdFiles.zzcl = item;
            break;
          case "17":
            this.thirdFiles.zscl = item;
            break;
        }
      })
      let jsry = this.extForm.subconManagePersonAndFilesBO.subconFileinfoBOS;
      let czglry = this.extForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS;
      let zybz = this.extForm.subconToDoPersonAndFilesBO.subconFileinfoBOS
      if(jsry.length > 0){
        jsry.forEach(item => {
          if(item.businessFileType == "16"){
            this.jsryxxFiles.gcyj = item
          }else if(item.businessFileType == "15") {
            this.jsryxxFiles.sbzm = item
          }else if(item.businessFileType == "14") {
            this.jsryxxFiles.ldht = item
          }
        })
      }
      if(czglry.length > 0){
        czglry.forEach(item => {
          if(item.businessFileType == "21"){
            this.czglryFiles.gcyj = item
          }else if(item.businessFileType == "20") {
            this.czglryFiles.sbzm = item
          }else if(item.businessFileType == "19") {
            this.czglryFiles.ldht = item
          }
        })
      }
      if(zybz.length > 0){
        zybz.forEach(item => {
          if(item.businessFileType == "24"){
            this.zybzFiles.gcyj = item
          }else if(item.businessFileType == "23") {
            this.zybzFiles.sbzm = item
          }else if(item.businessFileType == "22") {
            this.zybzFiles.ldht = item
          }
        })
      }
    },
  },
  data() {
    return {
      errorTips1: "",
      formTip: {},
      qualifiLevels: [
        {
          attribute2: "0101",
          post: "董事长"
        },
        {
          attribute2: "0102",
          post: "副董事长"
        },
        {
          attribute2: "0103",
          post: "职工代表董事"
        },
        {
          attribute2: "0201",
          post: "监事长"
        },
        {
          attribute2: "0202",
          post: "副监事长"
        },
        {
          attribute2: "0203",
          post: "职工代表监事"
        },
        {
          attribute2: "0301",
          post: "总经理"
        }
      ],
      qualification: [
        {
          attribute2: "01",
          post: "控股股东"
        },
        {
          attribute2: "02",
          post: "实控人"
        }
      ],
      downloadUrl: this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL +
          "/apis/sra/reg/users/signup/downloadByUploadId"
      ), //下载文件
      // loading开关
      formLoading: false,
      // 往来单位类别
      listSubconCategory: [],
      // 往来单位性质
      listSubconNature: [],
      categoryDialogVisible: false,
      centerDialogVisible: false,
      natureDialogVisible: false,
      listSubconBaseSubjectList: [],
      // 币种列表
      qryCurrencyList: [],
      uploadId: "",
      propsPlace: {
        checkStrictly: true,
        // checkStrictly: true,
        expandTrigger: "hover",
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            getCountryList({
              zcountryname: "中国",
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const cities = response.data.data.rows.map((value, i) => ({
                value: value.zcountrycode,
                label: value.zcountryname,
                leaf: false
              }));
              resolve(cities);
            });
          }
          if (node.level === 1) {
            getAdministrationList({
              zaddvsup: "0",
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const cities = [];
              response.data.data.rows.forEach(item => {
                cities.push({
                  value: item.zaddvscode,
                  label: item.zaddvsname,
                  leaf: false
                });
              });
              resolve(cities);
            });
          }
          if (node.level > 1 && node.level < 4) {
            getAdministrationList({
              zaddvsup: node.value,
              pageNo: 1,
              pageSize: 1000
            }).then(response => {
              const areas = response.data.data.rows.map((value, i) => ({
                value: value.zaddvscode,
                label: value.zaddvsname,
                leaf: node.level === 3
              }));
              resolve(areas);
            });
          }
        }
      },
      rules1: {
        subconName:[
          { required: true, message: "请输入分包商中文名称", trigger: "blur" },
        ],
        subconShortName:[
          { required: true, message: "请输入分包商简称", trigger: "change" },
        ],
        initUnitName:[
          { required: true, message: "请输入初始准入单位", trigger: "blur" },
        ],
        cooUnitName:[
          { required: true, message: "请输入合作单位", trigger: "blur" },
        ],
        subsidiaryGroupName: [
          { required: true, message: "请输入上级法人单位", trigger: "blur" },
        ],
        unifiedCreditCode: [
          {required: true,message: "请输入统一社会信用代码",trigger: "change"}
        ],
        subconUsName: [
          { required: true, message: "请输入分包商英文名称", trigger: "blur" },
        ],
        yesNo: [
          { required: true, message: "请选择是否内部单位", trigger: "change" },
        ],
        comNatureName: [
          { required: true, message: "请选择企业性质", trigger: "change" },
        ],
        subconLocalName: [
          { required: true, message: "请输入名称（当地语言）", trigger: "blur" },
        ],
        inputValue: [
          { required: true, message: "请选择所在地", trigger: "change" },
        ],
        subconCategoryName: [
          { required: true, message: "请选择往来单位类别", trigger: "change" },
        ],
        subconNatureName: [
          { required: true, message: "请选择往来单位性质", trigger: "change" },
        ]
      },
      // 注册人信息校验
      rules2: {
        authUserName: [
          {
            required: true,
            message: "请输入注册人姓名",
            trigger: "change"
          },
        ],
        cardType: [
          {
            required: true,
            message: "请选择注册人证件类型",
            trigger: "change"
          }
        ],
        authPersonIdCard: [
          {
            required: true,
            message: "请输入注册人证件号码",
            trigger: "blur"
          },
          {
            min: 9,
            max: 18,
            required: true,
            message: "请输入正确的注册人证件号码",
            trigger: "blur"
          }
        ],

        registerEmail: [
          { required: true, message: "请输入注册人邮箱", trigger: "change" },
          {
            required: false,
            pattern: /^\w{2,12}@[a-z0-9]+\.[a-z]{2,4}$/,
            message: "只支持输入邮箱格式",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入注册人手机号",
            trigger: "change"
          },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误",
            trigger: "blur"
          }
        ]
      },
      // 注册账户信息校验
      rules3: {
        legalPersonName: [
          {
            required: true,
            message: "请输入法人姓名",
            trigger: "blur"
          },
        ],
        legalPersonPhone: [
          {
            required: true,
            message: "请输入法人电话号码",
            trigger: "blur"
          }
        ],
        cardType: [
          {
            required: true,
            message: "请输入法人证件类型",
            trigger: "change"
          }
        ],
        legalPersonIdCard: [
          {
            required: true,
            message: "请输入法人证件号码",
            trigger: "blur"
          },
          // {
          //   min: 9,
          //   max: 18,
          //   required: true,
          //   message: "请输入正确的法人证件号码",
          //   trigger: "blur"
          // }
        ],
        legalPersonCardValidityStart: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        legalPersonCardValidityEnd: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        legalPersonCardFront: [
          {
            required: true,
            message: "请上传身份证扫描件正面",
            trigger: "change"
          }
        ],
        legalPersonCardBack: [
          {
            required: true,
            message: "请上传身份证扫描件反面",
            trigger: "change"
          }
        ],
        isAuthCertificate: [
          { required: true, message: '请选择是否法人代表授权委托', trigger: 'change' }
        ],
        authCertificate: [
          {
            required: true,
            message: "请上传法人代表授权委托书扫描件",
            trigger: "change"
          }
        ],
      },
      // 分包商基本信息校验
      rules4: {
        registeredAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" }
        ],
        businessAddress: [
          { required: true, message: "请输入办公地址", trigger: "blur" }
        ],
        historyName: [
          { required: true, message: "请输入历史名称", trigger: "blur" }
        ],
        currencyCode: [
          { required: true, message: "请选择币种", trigger: "change" }
        ],
        registeredCapital: [
          { required: true, message: "请输入注册资本", trigger: "blur" }
        ],
        actualCapital: [
          { required: true, message: "请输入实缴资本", trigger:["blur","change" ] },
          {
            required: true,
            message: "实缴资本必须为数字值",
            trigger: "blur"
          }
        ],
        accountBank: [
          { required: true, message: "请输入基本存款账户", trigger: "blur" }
        ],
        bankNo: [
          { required: true, message: "请输入银行账号", trigger: "blur" }
        ],
        billingAddress: [
          { required: true, message: "请输入开票地址", trigger: "blur" }
        ],
        billingPhone: [
          { required: true, message: "请输入开票电话", trigger: "blur" }
        ],
        taxpayerType: [
          { required: true, message: "请选择纳税人类型", trigger: "change" }
        ],
        companySize: [
          { required: true, message: "请输入公司人数", trigger: "change" },
          {
            required: true,
            pattern: /^\d{1, 11}$/,
            message: "只能是整数,格式不对",
            trigger: "change"
          }
        ],
        socialStaffNum: [
          { required: true, message: "请输入参保人数", trigger: "blur" }
        ],
        companySetupTime: [
          { required: true, message: "请选择公司成立时间", trigger: "change" }
        ],
        businessStartTime: [
          {
            required: true,
            message: "请选择营业期限开始",
            trigger: ["change", "blur"]
          }
        ],
        businessEndTime: [
          { required: true, message: "请选择营业期限结束", trigger: "change" }
        ],
        issuingAuthority: [
          {
            required: true,
            message: "请选择营业执照发证机关",
            trigger: "change"
          }
        ],
        businessLicenseScan: [
          {
            required: true,
            message: "请上传营业执照附件",
            trigger: ["blur", "change"]
          }
        ],
        taxCertificate: [
          {
            required: true,
            message: "请上传证明",
            trigger: ["blur", "change"]
          }
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "blur" }
        ],
        safetyLicenseValidityStart: [
          {
            required: true,
            message: "请选择安全生产许可证有效期",
            trigger: "change"
          }
        ],
        safetyLicenseValidityEnd: [
          {
            required: true,
            message: "请选择安全生产许可证截止期",
            trigger: "change"
          }
        ],
        safetyLicenseIssAuth: [
          { required: true, message: "请输入安全许可发证机关", trigger: "blur" }
        ],
        securityClearanceNumber: [
          { required: true, message: "请输入安全生产许可证编号", trigger: "blur" }
        ],
        safetyLicenseEnclosure: [
          {
            required: true,
            message: "请上传安全许可证附件",
            trigger: ["blur", "change"]
          }
        ],
      },
      rules5: {
        subconCooProfessionBOS: [
          { type: 'array', required: true, message: '请至少选择一个分包商业务类别', trigger: 'change' }
        ],
        isJoinMerge: [
          { required: true, message: '请选择是否融合项目', trigger: 'change' }
        ],
      },
      rules6: {
        advanceFund: [
          { required: true, message: "请输入垫资能力", trigger: "blur" }
        ],
        subconFileinfoBOS: [
          {
            type: "array",
            required: true,
            message: "请上传资质证书附件",
            trigger: "change"
          }
        ],
      },
      rules7: {
        environmentalProtection: [
          {
            required: true,
            message: "请输入其他不良信息",
            trigger: ["blur", "change"]
          },
        ],
        illegal: [
          {
            required: true,
            message: "请输入企业违法行为",
            trigger: ["blur", "change"]
          },
        ],
        brokenPromises: [
          {
            required: true,
            message: "请输入失信被执行人情况",
            trigger: ["blur", "change"]
          },
        ],
      },
      rules8: {
        coreAndExpertise: [
          { required: true, message: "请输入施工核心技术及特长", trigger: "blur" }
        ],
      },
      rules9: {
        turnoverMaterial: [
          {
            required: true,
            message: "请上传周转材料附件",
            trigger: "change"
          }
        ],
      },
      rules: {
        subconUsName:[
          { required: false, message: "请输入分包商英文名称", trigger: "change" },
        ],
        subconShortName: [
          { required: true, message: "请输入分包商简称", trigger: "change" }
        ],
        yesNo: [
          {
            required: true,
            message: "请选择是否是内部单位",
            trigger: "change"
          }
        ],
        yesNoCopy: [
          {
            required: true,
            message: "请选择是否是内部单位",
            trigger: "change"
          }
        ],
        countrys: [
          { required: true, message: "请输入所在地", trigger: "change" }
        ],
        subconName: [
          { required: true, message: "请输入分包商名称", trigger: "change" }
        ],
        initUnitName: [
          { required: true, message: "请输入初始准入单位", trigger: "change" }
        ],
        cooUnitName: [
          { required: true, message: "请输入合作单位", trigger: "change" }
        ],
        subconCode: [
          {
            required: true,
            message: "请输入往来单位主数据编码",
            trigger: "change"
          }
        ],
        cooUnitCode: [
          {
            required: true,
            message: "请输入机构主数据编码",
            trigger: "change"
          }
        ],
        unifiedCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change"
          }
        ],
        comNatureName: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: "change"
          }
        ],
        subconCategoryName: [
          {
            required: true,
            message: "请选择往来单位类别",
            trigger: "change"
          }
        ],
        subconNatureName: [
          {
            required: true,
            message: "请选择往来单位性质",
            trigger: "change"
          }
        ],
        legalPersonPhone: [
          { required: true, message: "请输入法人电话号码", trigger: "change" },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误"
          }
        ],
        legalPersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" },
        ],
        legalPersonCardValidityStart: [
          {
            required: true,
            message: "请输入法人证件号码有效期",
            trigger: "change"
          }
        ],
        legalPersonCardValidityEnd: [
          {
            required: true,
            message: "请输入法人证件号码截止期",
            trigger: "change"
          }
        ],
        legalPersonIdCard: [
          { required: true, message: "请输入正确的身份证号码", trigger: "change" },
          {
            min: 9,
            max: 18,
            required: true,
            message: "请输入法人证件号码",
            trigger: "blur"
          }
        ],
        legalPersonCardFront: [
          {
            required: true,
            message: "请输入法人身份证扫描件正面",
            trigger: ["blur", "change"]
          }
        ],
        legalPersonCardBack: [
          {
            required: true,
            message: "请输入法人身份证扫描件反面",
            trigger: ["blur", "change"]
          }
        ]
      },

      // 列表校验
      qualificationListRule: {
        list: [
          { required: true, message: "资历列表不能为空", trigger: "change" }
        ]
      },
      
    
      majorEquipmentRules: {
        list: [
          { required: true, message: "设备类表不能为空", trigger: "change" }
        ]
      },
      subconManagePerson: {
        list: [
          {
            required: true,
            message: "团队成员信息不能为空",
            trigger: "change"
          }
        ]
      },
      subconTyPfeRule: {
        list: [
          {
            required: true,
            message: "财务能力不能为空",
            trigger: "change"
          }
        ]
      },
      subconBusinessRule: {
        list: [
          {
            required: true,
            message: "业务联系人不能为空",
            trigger: "change"
          }
        ]
      },

      subconControlsRule: {
        list: [
          {
            required: true,
            message: "市场主体实控信息不能为空",
            trigger: "change"
          }
        ]
      },
      subconExecutiveRule: {
        list: [
          {
            required: true,
            message: "市场主体董监高信息不能为空",
            trigger: "change"
          }
        ]
      },
      qualificationListRule1: {
        list: [
          { required: true, message: "资历列表不能为空", trigger: "change" }
        ]
      },
      qualificationListRule2: {
        list: [
          { required: true, message: "技术人员信息不能为空", trigger: "change" }
        ]
      },
      qualificationListRule3: {
        list: [
          { required: true, message: "获奖情况不能为空", trigger: "change" }
        ]
      },
      qualificationListRule4: {
        list: [
          { required: true, message: "持证管理人员不能为空", trigger: "change" }
        ]
      },
      qualificationListRule5: {
        list: [
          { required: true, message: "作业班组不能为空", trigger: "change" }
        ]
      },
      qualificationListRule6: {
        list: [
          { required: true, message: "年生产能力不能为空", trigger: "change" }
        ]
      },
      qualificationListRule7: {
        list: [
          { required: true, message: "主要设备不能为空", trigger: "change" }
        ]
      },
      qualificationListRule8: {
        list: [
          { required: true, message: "业务承揽能力不能为空", trigger: "change" }
        ]
      },
      // 技术人员
      jsryxxFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      // 持证管理人员
      czglryFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      // 作业班组
      zybzFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      thirdFiles: {
        zzcl: null,
        zscl: null
      },
      error1: "",
      error2: "",
      error3: "",
      error4: "",
      error5: "",
      error6: "",
      error7: "",
      error8: "",
      error9: "",
      checkedBox: []
    };
  }
};
</script>

<style lang="scss" scoped>
.secondStep{
  padding: 0 90px;
  .title {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    position: relative;
    line-height: 20px;
    span {
      margin-right: 16px;
      height: 20px;
      display: inline-block;
      width: 4px;
      background: #ff152e;
    }
    div {
      position: absolute;
      //   top: -2px;
      display: inline-block;
    }
  }
  
}
.form_area{
  /deep/ .el-form-item{
    margin-bottom: 30px;
    .el-select {
      width: 100%;
    }
    .el-input__inner {
      height: 40px !important;
    }
    .el-date-editor {
      width: 100%;
    } 
  }
}
.table_form_area {
  /deep/ .el-table__body .cell {
    overflow: visible;
    .el-form-item__error {
      padding-top: 0px;
    }
  }
}
.checkbox_area {
  /deep/ .el-checkbox {
    width: 130px;
    line-height: 30px;
  }
}
.buttons {
  display: flex;
  justify-content: center;
    /deep/ .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    border: none;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .stopBtn {
    background: rgba(180, 111, 117, 0.08);
    border: 1px solid #ff152e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff152e;
  }
  .lastBtn {
    background: #fafafa;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
  }
}
// .www /deep/.el-form-item__label:before{
//   content: '*';
//   color: #F56C6C;
//   margin-right: 4px;
// }
// .secondStep {
//   padding: 0 90px;
//   // margin-left: 90px;
//   // display: flex;
//   // justify-content: center;
//   // align-content: center;
//   .title {
//     width: 100%;
//     height: 50px;
//     font-size: 16px;
//     font-family: PingFangSC-Medium, PingFang SC;
//     font-weight: 500;
//     color: #000000;
//     position: relative;
//     line-height: 20px;
//     span {
//       margin-right: 16px;
//       height: 20px;
//       display: inline-block;
//       width: 4px;
//       background: #ff152e;
//     }
//     div {
//       position: absolute;
//       //   top: -2px;
//       display: inline-block;
//     }
//   }
//   .el-form-item {
//     font-size: 14px !important;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 0.85) !important;
//     /deep/.el-form-item__error{
//       position: static!important;
//     }
//     /deep/.el-form-item__label {
//       font-size: 14px;
//       font-family: PingFangSC-Regular, PingFang SC;
//       font-weight: 400;
//       color: rgba(0, 0, 0, 0.85);
//     }
//     /deep/.el-cascader,
//     /deep/.el-cascader .el-input .el-input__inner {
//       height: 40px !important;
//       width: 280px;
//       .el-input__icon {
//         line-height: 40px;
//       }
//     }
//     /deep/.el-cascader .el-input .el-icon-caret-bottom {
//       line-height: 40px;
//     }
//   }
//   .el-form-item__content .el-input /deep/input,
//   .el-select /deep/.el-input input {
//     width: 1006px;
//     float: left;
//     max-width: 280px;
//     height: 40px !important;
//     background: #ffffff;
//     border-radius: 2px;
//     border: 1px solid #e9ecf7;
//   }

//   /deep/.el-form-item__content,
//   .el-form-item__content /deep/.e-input {
//     /*width: 450px;*/
//     .el-form-item__error {
//       padding: 0;
//     }
//   }
//   /deep/.el-area-selector .selected-adress .selected-show {
//     min-width: 250px;
//     height: 40px;
//     line-height: 40px;
//     padding: 0 20px 0 9px;
//     font-size: 14px;
//     color: #4a4a4a;
//     display: block;
//     border: 1px solid #e9e9e9;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//   }
//   .el-form-item__content .el-button {
//     width: 82px;
//     height: 40px;
//     background: #ff152e;
//     border-radius: 2px;
//     font-size: 14px;
//     border: none;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: #ffffff;
//   }
//   .el-form-item__content .stopBtn {
//     background: rgba(180, 111, 117, 0.08);
//     border: 1px solid #ff152e;
//     font-size: 14px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: #ff152e;
//   }
//   .demo-ruleForm .masterDataInformation {
//     // width: 75%;
//   }
//   .el-row .el-col {
//     display: inline-block;
//   }
//   .secondStep .el-form-item__content .el-input[data-v-4b198370] /deep/input,
//   .secondStep .el-select[data-v-4b198370] .el-input /deep/input {
//     height: 130px;
//     background: #eee;
//   }
//   .deviation {
//     position: relative;
//     // left: -100px;
//   }
//   .addTabIndex /deep/.el-form-item__content {
//     width: 1006px;
//   }
//   .el-form-item__content .nextBtn {
//     width: 82px;
//     height: 40px;
//     background: #ff152e;
//     border-radius: 2px;
//     font-size: 14px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: #ffffff;
//   }
//   .el-form-item__content .lastBtn {
//     background: #fafafa;
//     border: 1px solid #dddddd;
//     font-size: 14px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 0.25);
//   }
// }
// .el-table {
//   border: 1px solid #fafafa;
//   /deep/tbody tr {
//     height: 45px !important;
//   }
//   /deep/thead tr th {
//     div {
//       font-size: 14px;
//       font-family: PingFangSC-Medium, PingFang SC;
//       font-weight: 500;
//       color: rgba(0, 0, 0, 0.85);
//     }
//   }
//   /deep/.el-table__body-wrapper .el-table__body tbody tr td div {
//     font-size: 14px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 0.65);
//   }
// }
// .buttons {
//   display: flex;
//   justify-content: center;
// }
</style>
